import { ImageNewPattern, ImageOldPattern } from './ImageConverter';
import AttachmentUrlConverter from './AttachmentUrlConverter';
import ThumbnailFarm from './ThumbnailFarm';

const FilePattern = new RegExp(/\[##_File\|([^|]+)\|([^|]*)\|([^|]*?)_##\]/mgi);
const FilenamePattern = new RegExp(/filename="([^"]*?)(\.\w+)?"/);
const SizePattern = new RegExp(/size="([^"]+)"/);

function getFilename (attributes) {
  const matched = attributes.match(FilenamePattern);
  if (matched) {
    return {
      name: matched[1],
      type: matched[2] ? matched[2] : '',
    };
  } else {
    return {
      name: '첨부파일',
      type: '',
    };
  }
}

function getSize (attributes) {
  const matched = attributes.match(SizePattern);
  if (matched) {
    return matched[1];
  } else {
    return '다운로드';
  }
}

function getFileHtml (key, attributes) {
  const filename = getFilename(attributes);
  const size = getSize(attributes);
  return `<figure data-ke-type="file" contenteditable="false"><a href="${AttachmentUrlConverter.toUrl(key)}"><div class="image"></div><div class="desc"><p class="filename"><span class="name">${filename.name}</span><span class="type">${filename.type}</span></p><p class="size">${size}</p></div></a></figure>`;
}


class FileConverter {
  static toHtml (content) {
    if (ImageOldPattern.test(content)) {
      content = content.replace(ImageOldPattern, (match, type, key, attributes, caption) => getFileHtml(key, attributes));
    }

    if (ImageNewPattern.test(content)) {
      content = content.replace(ImageNewPattern, (match, type, key, style, attributes, caption) => getFileHtml(key, attributes));
    }

    if (FilePattern.test(content)) {
      content = content.replace(FilePattern, (match, key, attributes, caption) => getFileHtml(key, attributes));
    }

    return content;
  }

  static toTistory (editor, e) {
    const { $ } = editor.dom;
    $('[data-ke-type="file"]', e.node).each((idx, elm) => {
      const $elm = $(elm);
      const $anchor = $elm.find('a');
      const url = AttachmentUrlConverter.toTistory(ThumbnailFarm.from($anchor.attr('href')));
      const filename = $anchor.find('.filename').text().trim();
      const size = $anchor.find('.size').text().trim();

      elm.parentNode.replaceChild(editor.getDoc().createTextNode(`[##_File|${url}|filename="${filename}" size="${size}"|_##]`), elm);
    });
  }
}

export default FileConverter;
